"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTicketFulfillmentStatus = exports.CommandFulfillmentStatus = exports.FulfillmentMethod = exports.OfferedFulfillmentMethod = void 0;
var OfferedFulfillmentMethod;
(function (OfferedFulfillmentMethod) {
    OfferedFulfillmentMethod["Pickup"] = "pickup";
    OfferedFulfillmentMethod["Shipping"] = "shipping";
})(OfferedFulfillmentMethod || (exports.OfferedFulfillmentMethod = OfferedFulfillmentMethod = {}));
var FulfillmentMethod;
(function (FulfillmentMethod) {
    FulfillmentMethod["Pickup"] = "pickup";
    FulfillmentMethod["Shipping"] = "shipping";
    FulfillmentMethod["None"] = "none";
})(FulfillmentMethod || (exports.FulfillmentMethod = FulfillmentMethod = {}));
var CommandFulfillmentStatus;
(function (CommandFulfillmentStatus) {
    CommandFulfillmentStatus["NotFulfilled"] = "not_fulfilled";
    CommandFulfillmentStatus["PartiallyReady"] = "partially_ready";
    CommandFulfillmentStatus["Ready"] = "ready";
    CommandFulfillmentStatus["PartiallyFulfilled"] = "partially_fulfilled";
    CommandFulfillmentStatus["Fulfilled"] = "fulfilled";
})(CommandFulfillmentStatus || (exports.CommandFulfillmentStatus = CommandFulfillmentStatus = {}));
var ProductTicketFulfillmentStatus;
(function (ProductTicketFulfillmentStatus) {
    ProductTicketFulfillmentStatus["NotFulfilled"] = "not_fulfilled";
    ProductTicketFulfillmentStatus["Ready"] = "ready";
    ProductTicketFulfillmentStatus["Fulfilled"] = "fulfilled";
})(ProductTicketFulfillmentStatus || (exports.ProductTicketFulfillmentStatus = ProductTicketFulfillmentStatus = {}));
